import * as React from 'react';
import { RouteComponentProps } from 'react-router';

export class Forbidden extends React.Component<RouteComponentProps<{}>, {}> {
    public render() {
        return (
            <div>
                <h1>Access Denied</h1>
                <p>You don't have permissions for this page!</p>
            </div>
        );
    }
}
